import { useQuery } from '@tanstack/react-query'
import { reactQueryKeys } from 'reactQueryKeys/reactQueryKeys'
import { getWalletTransactionById } from 'services/TransactionService'

export const useWalletTransactionDetailsQuery = (transactionUUID: string | undefined) => {
  return useQuery({
    queryKey: reactQueryKeys.walletTransactionDetails({ transactionUUID: transactionUUID ?? '' }),
    queryFn: () => getWalletTransactionById({ transactionUUID: transactionUUID ?? '' }),
    enabled: !!transactionUUID,
  })
}
